import React, {useEffect, useRef} from "react"
import {TableCell} from "./TableCell"

export function TableRow({type, handleClick, expandedRow, rowId, selected, data}) {
  let columns
  let testId
  if (type === "category") {
    columns = ["category", " ", "  ", "locations", "visits"] // We need to fill different cells for different rows
    // columns = ["category", " ", "locations", "visits", "bookmarked"] // We need to fill different cells for different rows
    testId = "category-row"
  } else if (type === "brand") {
    columns = [" ", "brand", "brandLocations", "insights", "locations", "visits"]
    // columns = [" ", "brand", "insights", "locations", "visits", "bookmarked"]
    testId = "brand-row"
  }

  const scrollPoint = useRef()

  //scroll for searched brand or category
  useEffect(() => {
    setTimeout(() => {
      if (scrollPoint.current && selected === rowId)
        scrollPoint.current.scrollIntoView({behavior: "smooth", block: "center"})
    }, 250)
  }, [selected])

  const tablerow = columns.map((column) => {
    return (
      <TableCell key={column} item={data} cellType={column} expandedRow={expandedRow} />
    )
  })

  return (
    <tr
      ref={scrollPoint}
      data-testid={testId}
      onClick={() => handleClick(rowId)}
      className={"row" + (selected === rowId ? "selected" : "")}
    >
      {tablerow}
    </tr>
  )
}
